import React from "react";

const Logo = () => {
  return (
    <div className="text-center  ">
      <h1 className="font-bold leading-tight mr-3 w-40">
        <span className="block bg-gradient-to-r from-[#4A1D85] to-[#156FBC] bg-clip-text text-transparent ibm tracking-tight text-4xl">
          UdrLight
        </span>
        <span className="block bg-gradient-to-r from-[#4A1D85] to-[#156FBC] bg-clip-text text-transparent px-1 font-monoCustom">
          Innovation Center
        </span>
      </h1>
    </div>
  );
};

export default Logo;
